import { VERSION_DEFAULT } from 'Common/constants';
import { getMatter } from 'Common/Utils/MatterProps';

export const isSuperSplittingSupported = () => {
  const matter = getMatter();
  const version = matter.version || VERSION_DEFAULT;

  return version >= '20230215';
};
